import { Box, Flex, Text } from '@chakra-ui/react';
import EmptyState from './EmptyState';
import { ExpertInviteList } from 'src/api/queries';
import { IEarlyAssessmentListItem } from '@publishing-engine/domain/views';
import { useState } from 'react';
import { ButtonText } from '@morressier/alembic';
import ViewAssessmentModal from './ViewAssessmentModal';

interface Props {
  data: ExpertInviteList | null | undefined;
}
const EarlyAssessmentsInPeerReviewPhase = ({ data }: Props) => {
  const [selectedViewAssessment, setSelectedViewAssessment] =
    useState<IEarlyAssessmentListItem | null>(null);
  const showCompletedAssessment = data?.items.filter(
    item => item.workflow.currentState === 'reviewed'
  );
  return (
    <>
      {selectedViewAssessment ? (
        <ViewAssessmentModal
          assessmentData={selectedViewAssessment}
          onClose={() => setSelectedViewAssessment(null)}
          type="Early Assessment"
        />
      ) : null}
      <Box marginTop={6}>
        {data &&
        data?.items?.some(item => item.workflow.currentState === 'reviewed') ? (
          <>
            <Flex flexDirection="column" marginBottom={6}>
              <Text textStyle="headingSection">Early Assessments</Text>
              <Text>
                This work is only active in Initial Assessment phase. Our system
                carried over the following completed work:
              </Text>
            </Flex>
            {showCompletedAssessment?.map(item => (
              <Flex
                justifyContent="space-between"
                alignItems="center"
                flexDirection="row"
                padding={4}
                bgColor="surfacePrimaryFill"
                borderColor="neutralPrimaryBorder"
                width="100%"
                marginY={3}
              >
                <Flex flexDirection="column">
                  <Text textStyle="headingItem">
                    {item.expert.firstName} {item.expert.lastName}
                  </Text>
                  <Text>
                    {item.expert.affiliationDetails?.organizationName}
                  </Text>
                </Flex>
                <ButtonText
                  onClick={() => setSelectedViewAssessment(item ?? null)}
                >
                  View Assessment
                </ButtonText>
              </Flex>
            ))}
          </>
        ) : (
          <EmptyState
            title="No Early Assessments"
            subTitle="No early assessments were carried over from the Initial Assessment phase."
            headingText="Early Assessments"
            subHeadingText="This work is only active in Initial Assessment phase."
            isFileIcon
          />
        )}
      </Box>
    </>
  );
};

export default EarlyAssessmentsInPeerReviewPhase;
